/* Version 1.0.2 - Fix quantity zero being converted to 1 on blur/change events */
(function () {
  function initCustomJS($) {
    /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
    $(document).on("variant:changed", function (evt) {
      // $('[data-variant-toggle]').hide(0);
      // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);

      // Update price display when variant changes
      if (evt.currentVariant) {
        var variant = evt.currentVariant;

        var $currentPrice = $('.dtc-current-price');
        var $comparePrice = $('.dtc-compare-price');
        var $saveBadge = $('.dtc-save-badge');
        var $shoppayText = $('.dtc-shoppay-text strong');

        // Clear existing price elements
        $('.dtc-price-wrapper').empty();

        // Always show current price
        $('.dtc-price-wrapper').append(
          '<span class="dtc-current-price" data-price="' +
          variant.price + '">' +
          formatMoney(variant.price) + '</span>'
        );

        // Always show compare price
        var comparePrice = variant.compare_at_price || variant.price;
        $('.dtc-price-wrapper').append(
          '<span class="dtc-compare-price" data-compare-price="' +
          comparePrice + '">' +
          formatMoney(comparePrice) + '</span>'
        );

        // Show save badge only if there's a discount
        var saveAmount = comparePrice - variant.price;
        if (saveAmount > 0) {
          $('.dtc-price-wrapper').append(
            '<span class="dtc-save-badge" data-save-amount="' +
            saveAmount + '">Save ' + formatMoney(saveAmount) + '</span>'
          );
        }

        // Update Shop Pay installment price
        if ($shoppayText.length > 0) {
          var installmentPrice = variant.price / 4;
          $shoppayText.text(formatMoney(installmentPrice));
        }
      }
    });

    /**
     *  Navigation categories toggle
     */
    $(document).on('click', '.t4s-nav-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $navItem = $(this).closest('.t4s-nav-item');
      var isExpanded = $navItem.hasClass('t4s-nav-item--expanded');

      if (isExpanded) {
        $navItem.removeClass('t4s-nav-item--expanded');
        $(this).find('svg').html('<line x1="6.5" y1="2" x2="6.5" y2="11" stroke="#666" stroke-width="2" stroke-linecap="round"/><line x1="2" y1="6.5" x2="11" y2="6.5" stroke="#666" stroke-width="2" stroke-linecap="round"/>');
      } else {
        $navItem.addClass('t4s-nav-item--expanded');
        $(this).find('svg').html('<line x1="2" y1="6.5" x2="11" y2="6.5" stroke="#1B8C92" stroke-width="2" stroke-linecap="round"/>');
      }

      return false;
    });

    $(document).on('click', '.t4s-size-tag', function (e) {
      e.preventDefault();
      $('.t4s-size-tag').removeClass('t4s-size-tag--active');
      $(this).addClass('t4s-size-tag--active');
    });

    /**
     *  Dropdown menu functionality
     *  data-dropdown-open, data-dropdown-close, data-dropdown-item
     */
    $(document).on('click', '[data-dropdown-open]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var dropdownId = $button.data('id');
      var $dropdown = $('#' + dropdownId);

      if ($dropdown.length === 0) return;

      var isOpened = $dropdown.hasClass('is--opened');

      $('[data-dropdown-wrapper].is--opened').removeClass('is--opened');

      if (!isOpened) {
        $dropdown.addClass('is--opened');

        var position = $button.data('position') || 'bottom-start';
        var buttonOffset = $button[0].getBoundingClientRect();
        var buttonHeight = $button.outerHeight();
        var buttonWidth = $button.outerWidth();
        var dropdownWidth = $dropdown.outerWidth();
        var dropdownHeight = $dropdown.outerHeight();
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();
        var scrollTop = $(window).scrollTop();
        var scrollLeft = $(window).scrollLeft();

        var top, left;
        var arrowLeft;

        if (position === 'bottom-end') {
          top = buttonOffset.top + buttonHeight + scrollTop;
          left = buttonOffset.left + buttonWidth - dropdownWidth + scrollLeft;
          arrowLeft = dropdownWidth - (buttonWidth / 2) - 8;
        } else if (position === 'bottom-start') {
          top = buttonOffset.top + buttonHeight + scrollTop;
          left = buttonOffset.left + scrollLeft;
          arrowLeft = (buttonWidth / 2) - 8;
        } else {
          top = buttonOffset.top + buttonHeight + scrollTop;
          left = buttonOffset.left + scrollLeft;
          arrowLeft = (buttonWidth / 2) - 8;
        }

        if (left < 0) {
          arrowLeft = arrowLeft + left - 10;
          left = 10;
        }
        if (left + dropdownWidth > windowWidth) {
          arrowLeft = arrowLeft + (left + dropdownWidth - windowWidth + 10);
          left = windowWidth - dropdownWidth - 10;
        }
        if (buttonOffset.top + buttonHeight + dropdownHeight > windowHeight) {
          top = buttonOffset.top - dropdownHeight + scrollTop;
        }

        $dropdown.css({
          'position': 'absolute',
          'top': top + 'px',
          'left': left + 'px',
          'transform': 'translateY(0)'
        });

        var $arrow = $dropdown.find('.t4s-drop-arrow');
        if ($arrow.length && windowWidth >= 768) {
          $arrow.css({
            'top': '-8px',
            'left': arrowLeft + 'px'
          });
        }
      }
    });

    $(document).on('click', '[data-dropdown-close]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).closest('[data-dropdown-wrapper]').removeClass('is--opened');
    });

    $(document).on('click', '[data-dropdown-item]', function (e) {
      e.preventDefault();

      var $item = $(this);
      var $dropdown = $item.closest('[data-dropdown-wrapper]');
      var $content = $dropdown.find('.t4s-dropdown__content');

      $content.find('[data-dropdown-item]').removeClass('is--selected');
      $item.addClass('is--selected');

      var $button = $('[data-id="#' + ($dropdown.attr('id') || '') + '"]');
      if ($button.length === 0) {
        $button = $('[data-id="' + ($dropdown.attr('id') || '') + '"]');
      }

      if ($item.attr('data-sortby-item') !== undefined) {
        var sortValue = $item.attr('data-value');
        var sortName = $item.text() || '';

        if ($button.length) {
          $button.find('span:first').text(sortName);
        }

        if (sortValue) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortValue);

          window.location.href = url.toString();
        }
      }

      $dropdown.removeClass('is--opened');
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('[data-dropdown-open], [data-dropdown-wrapper]').length) {
        $('[data-dropdown-wrapper].is--opened').removeClass('is--opened');
      }
    });

    $(window).on('scroll', function () {
      $('[data-dropdown-wrapper].is--opened').removeClass('is--opened');
    });

    $(window).on('resize', function () {
      $('[data-dropdown-wrapper].is--opened').removeClass('is--opened');
    });

    /**
     *  Filter area toggle for area mode
     *  data-toggle-filter
     */
    $(document).on('click', '[data-toggle-filter]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $filterArea = $button.closest('.t4s-section-inner').find('[data-filter-area]');

      if ($filterArea.length === 0) return;

      var isOpened = $filterArea.hasClass('is--filters-opened');

      if (isOpened) {
        $filterArea.removeClass('is--filters-opened');
        $filterArea.stop().slideUp(200);
        $button.removeClass('is--clicked');
      } else {
        $filterArea.addClass('is--filters-opened');
        $filterArea.stop().slideDown(200);
        $button.addClass('is--clicked');
      }

      return false;
    });

    /**
     *  Layout switch functionality
     *  data-layout-switch
     */
    $(document).on('click', '[data-layout-switch] button', function (e) {
      e.preventDefault();

      var $button = $(this);
      var $wrapper = $button.closest('[data-layout-switch]');
      var breakpoint = $button.attr('data-breakpoint');
      var col = $button.attr('data-col');

      $wrapper.find('button[data-breakpoint="' + breakpoint + '"]').removeClass('is--active');
      $button.addClass('is--active');

      var $products = $button.closest('.t4s-section-inner').find('.t4s-products');
      if ($products.length === 0) {
        $products = $('.t4s-products');
      }

      if ($products.length === 0) return;

      var productsClasses = $products.attr('class');
      var newClasses = productsClasses;

      var breakpointSuffix = '';
      if (breakpoint === 'tablet') {
        breakpointSuffix = '-md';
      } else if (breakpoint === 'desktop') {
        breakpointSuffix = '-lg';
      }

      var colPattern = new RegExp('t4s-row-cols' + breakpointSuffix + '-\\d+', 'g');
      newClasses = newClasses.replace(colPattern, '');

      var listviewPattern = new RegExp('is--listview\\s*on--list-' + breakpoint + '\\s*', 'g');
      newClasses = newClasses.replace(listviewPattern, '');
      newClasses = newClasses.replace(/is--listview\s*/g, '');
      newClasses = newClasses.replace(/on--list-\w+\s*/g, '');

      if (col === 'list_t4s') {
        newClasses = newClasses + ' is--listview on--list-' + breakpoint;
      } else {
        newClasses = newClasses + ' t4s-row-cols' + breakpointSuffix + '-' + col;
      }

      $products.attr('class', newClasses);

      var url = new URL(window.location.href);
      url.searchParams.set('view_cols_' + breakpoint, col);
      window.history.replaceState({}, '', url.toString());
    });

    /**
     *  Load filter content into filter-area on page load
     */
    $(document).on('facets:loaded:adm', function (e, $filterArea, $section) {
      if ($filterArea.length === 0) return;

      var $drawerScroll = $('#t4s-filter-hidden .t4s-drawer__scroll');
      if ($drawerScroll.length > 0 && $filterArea.children().length === 0) {
        $filterArea.html($drawerScroll.html());
      }
    });

    /**
     *  Initialize filter area on document ready
     */
    $(document).ready(function () {
      setTimeout(function () {
        var $filterArea = $('[data-filter-area]');
        if ($filterArea.length > 0 && $filterArea.children().length === 0) {
          var $drawerScroll = $('#t4s-filter-hidden .t4s-drawer__scroll');
          if ($drawerScroll.length > 0) {
            $filterArea.html($drawerScroll.html());
            $(document).trigger('collection-filter:content-updated');
          }
        }
      }, 1000);
    });

    /**
     *  Initialize filter area on window load
     */
    $(window).on('load', function () {
      setTimeout(function () {
        var $filterArea = $('[data-filter-area]');
        if ($filterArea.length > 0 && $filterArea.children().length === 0) {
          var $drawerScroll = $('#t4s-filter-hidden .t4s-drawer__scroll');
          if ($drawerScroll.length > 0) {
            $filterArea.html($drawerScroll.html());
            $(document).trigger('collection-filter:content-updated');
          }
        }
      }, 500);
    });

    /**
     *  Back to top button functionality
     */
    var $backToTopBtn = $('#t4s-backToTop');
    if ($backToTopBtn.length > 0) {
      var scrollThreshold = parseInt($backToTopBtn.data('scrolltop')) || 100;
      var hiddenMobile = $backToTopBtn.data('hidden-mobile') === 'true';
      
      function toggleBackToTop() {
        var scrollTop = $(window).scrollTop();
        
        if (hiddenMobile && $(window).width() < 768) {
          $backToTopBtn.removeClass('is--show');
          return;
        }
        
        if (scrollTop > scrollThreshold) {
          $backToTopBtn.addClass('is--show');
        } else {
          $backToTopBtn.removeClass('is--show');
        }
      }
      
      $(window).on('scroll', toggleBackToTop);
      $(window).on('resize', toggleBackToTop);
      
      toggleBackToTop();
      
      $backToTopBtn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 600);
        return false;
      });
    }

    /**
     *  Quantity selector functionality
     *  data-quantity-selector, data-quantity-value, data-quantity-wrapper
     */
    function formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = '${{amount}}';

      function defaultOption(opt, def) {
        return typeof opt === 'undefined' ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      value = formatWithDelimiters(cents, 2);

      return formatString.replace(placeholderRegex, value);
    }

    function updateCartItemQuantity($input, newQuantity) {
      var itemKey = $input.data('id');

      if (!itemKey) return;

      var $cartItem = $input.closest('[data-cart-item]');
      var $cartWrapper = $input.closest('[data-cart-wrapper]');

      if ($cartItem.length === 0 || $cartWrapper.length === 0) return;

      $cartWrapper.addClass('is--contentUpdate');
      $cartItem.addClass('is--update');

      var $loadingBar = $cartItem.find('.t4s-cart-ld__bar');
      var $spinner = $cartItem.find('.t4s-cart-spinner');

      if ($loadingBar.length) $loadingBar.removeAttr('hidden');
      if ($spinner.length) $spinner.removeAttr('hidden');

      fetch(window.T4Sroutes.cart_change_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQuantity
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Notices) {
              T4SThemeSP.Notices(data.description);
            }
            $input.val($input.data('current-qty'));
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
            T4SThemeSP.Cart.getToFetch();
          }
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          $input.val($input.data('current-qty'));
        })
        .finally(() => {
          $cartWrapper.removeClass('is--contentUpdate');
          $cartItem.removeClass('is--update');
          if ($loadingBar.length) $loadingBar.attr('hidden', '');
          if ($spinner.length) $spinner.attr('hidden', '');
        });
    }

    $(document).on('click', '[data-quantity-selector]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $wrapper = $button.closest('[data-quantity-wrapper]');
      var $input = $wrapper.find('[data-quantity-value]');

      if ($input.length === 0) return;

      var currentValue = parseInt($input.val());
      if (isNaN(currentValue)) currentValue = 1;
      var min = parseInt($input.attr('min')) || 1;
      var max = parseInt($input.attr('max')) || 9999;

      if ($button.is('[data-decrease-qty]')) {
        if (currentValue <= 1) {
          currentValue = 0;
        } else {
          currentValue = Math.max(min, currentValue - 1);
        }
      } else if ($button.is('[data-increase-qty]')) {
        currentValue = Math.min(max, currentValue + 1);
      }

      $input.val(currentValue);

      if ($input.closest('[data-cart-item]').length > 0) {
        updateCartItemQuantity($input, currentValue);
      }

      return false;
    });

    $(document).on('change', '[data-quantity-value]', function (e) {
      var $input = $(this);
      var parsedValue = parseInt($input.val());
      var value = isNaN(parsedValue) ? 1 : parsedValue;
      var min = parseInt($input.attr('min')) || 1;
      var max = parseInt($input.attr('max')) || 9999;

      if (value === 0) {
        $input.val(0);
      } else {
        value = Math.max(min, Math.min(max, value));
        $input.val(value);
      }

      if ($input.closest('[data-cart-item]').length > 0) {
        updateCartItemQuantity($input, value);
      }
    });

    $(document).on('input', '[data-quantity-value]', function (e) {
      var $input = $(this);
      var value = $input.val();

      value = value.replace(/[^0-9]/g, '');

      if (value === '') {
        value = '1';
      }

      $input.val(value);
    });

    $(document).on('blur', '[data-quantity-value]', function (e) {
      var $input = $(this);
      var parsedValue = parseInt($input.val());
      var value = isNaN(parsedValue) ? 1 : parsedValue;
      var min = parseInt($input.attr('min')) || 1;
      var max = parseInt($input.attr('max')) || 9999;

      if (value === 0) {
        $input.val(0);
      } else {
        value = Math.max(min, Math.min(max, value));
        $input.val(value);
      }

      if ($input.closest('[data-cart-item]').length > 0) {
        updateCartItemQuantity($input, value);
      }
    });

    /**
     *  Color swatch wrapper selection
     *  Handle is--selected class on wrapper element
     *  On mobile, scroll to product media gallery
     */
    $(document).on('click', '.t4s-swatch__item-wrapper', function (e) {
      var $wrapper = $(this);
      var $swatchOption = $wrapper.closest('.t4s-swatch__option');

      $swatchOption.find('.t4s-swatch__item-wrapper').removeClass('is--selected');
      $wrapper.addClass('is--selected');

      // Mobile scroll to product media gallery
      if ($(window).width() <= 480) {
        var $productMedia = $('.dtc-product-media, .t4s-product__media-wrapper');
        
        if ($productMedia.length > 0) {
          var mediaOffset = $productMedia.offset().top;
          var scrollTop = mediaOffset - 20;
          
          $('html, body').animate({
            scrollTop: scrollTop
          }, 400);
        }
      }
    });

    /**
     *  Color swatch item selection (dropdown mode)
     *  On mobile, scroll to product media gallery
     */
    $(document).on('click', '.t4s-swatch__item[data-dropdown-off]', function (e) {
      var $item = $(this);
      var $swatchOption = $item.closest('.t4s-swatch__option');

      // Check if this is a color option (has is-t4s-style__color class)
      if ($swatchOption.hasClass('is-t4s-style__color')) {
        // Mobile scroll to product media gallery
        if ($(window).width() <= 480) {
          var $productMedia = $('.dtc-product-media, .t4s-product__media-wrapper');
          
          if ($productMedia.length > 0) {
            var mediaOffset = $productMedia.offset().top;
            var scrollTop = mediaOffset - 20;
            
            // Delay scroll to allow dropdown to close first
            setTimeout(function() {
              $('html, body').animate({
                scrollTop: scrollTop
              }, 400);
            }, 100);
          }
        }
      }
    });

    /**
     *  Checkout button validation
     *  Validate terms and conditions checkbox before checkout
     */
    $(document).on('click', '[data-confirm]', function (e) {
      var $button = $(this);
      var confirmName = $button.data('confirm');
      
      if (!confirmName) return;
      
      var $checkbox = $('input[name="' + confirmName + '"]');
      
      if ($checkbox.length === 0) return;
      
      if (!$checkbox.is(':checked')) {
        e.preventDefault();
        e.stopPropagation();
        
        if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Notices) {
          T4SThemeSP.Notices('Please accept the terms and conditions before checkout.');
        } else {
          alert('Please accept the terms and conditions before checkout.');
        }
        
        return false;
      }
    });


  }

  function initWhenReady() {
    if (typeof jQuery_T4NT !== 'undefined') {
      jQuery_T4NT(document).ready(function ($) {
        initCustomJS($);
      });
    } else if (typeof jQuery !== 'undefined') {
      jQuery(document).ready(function ($) {
        initCustomJS($);
      });
    } else {
      setTimeout(initWhenReady, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();


